import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { creditApi } from "../../apis/credit";

interface CreditInitialState {
  /** 총 사용 가능 크레딧(사용 가능 엑스포트 크레딧) */
  totalAvailableCredit: number;
}

const initialState: CreditInitialState = {
  totalAvailableCredit: 0,
};

export const creditSlice = createSlice({
  name: "credit",
  initialState,
  reducers: {
    changeTotalAvailableCredit: (state, action: PayloadAction<number>) => {
      state.totalAvailableCredit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);

    builder.addMatcher(
      creditApi.endpoints.getCreditStatusInfo.matchFulfilled,
      (state, { payload }) => {
        if (payload.totalAvailableCredit) {
          state.totalAvailableCredit = payload.totalAvailableCredit;
        }
      }
    );
  },
});

export default creditSlice.reducer;
export const { changeTotalAvailableCredit } = creditSlice.actions;
